<router-view v-if="!isAppLoading"></router-view>
<loading v-model:active="isAppLoading" :can-cancel="false" :is-full-page="true" :color="app_base_data.main_theme_color" loader="bars"
    background-color="app_base_data.second_theme_color" />
<p-toast></p-toast>
<p-confirm-dialog />

